<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            GoodFirms Features Kalpita Technologies
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/news-main/goodfirms-bannerimg.gif" alt="Manager"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Kalpita Technologies, led by CEO Kube G, is a Bangalore & Austin-based tech firm specializing in AI,
          automation, and enterprise software development.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>The company helps global clients in InsurTech, FinTech, and Healthcare with digital transformation, custom
          software, cloud, and automation.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Recognized as a Great Place to Work® and SOC II certified, Kalpita has delivered impactful solutions like
          cutting insurance processing from 10 days to 2 with AI automation.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>With 70% repeat clients, Kalpita stands out for innovation, agility, and people-first culture, aiming to be a
          leader in applied AI and sustainable tech over the next decade.</p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>GoodFirms Visibility : </strong>Boosted brand credibility, client inquiries, and website traffic.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Core Expertise : </strong>AI-enabled automation, enterprise software development, UI/UX, digital
          product engineering, and cloud & DevOps.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Industries Served : </strong>Strong presence in Insurance, Healthcare, and FinTech with ~70% repeat
          clients.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Notable Achievements : </strong>Expansion to the US (Austin), ISO & SOC II certifications, “Great
          Place to Work®” recognition, and 7+ years of growth.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Client Success Story : </strong>AI-powered platform reduced insurance errors by 70%, cut processing
          time by 80%, and boosted submissions 3X.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Culture & Values : </strong>Innovation, agility, empathy, excellence, and integrity — fostering a
          flat, Agile, and collaborative work model.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Employee Growth : </strong>Continuous training, certifications, and monthly webinars to keep talent
          future-ready.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Business Model : </strong>Mostly in-house delivery for quality and speed; flexible pricing from $10K
          to $2M projects.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p><strong>Future Vision : </strong>Expand across North America & Europe, lead in applied AI, build proprietary
          IP, and invest in green tech & sustainability.</p>
      </div>
    </div>
    <a href="https://www.goodfirms.co/company/kalpita-technologies#interview" target="_blank"
      class="btn case-study-btn">
      Read Full Article
    </a>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-newsarticle></app-relevant-newsarticle>